import { TContractItemsListRecord } from '../types'

export const mapData = (data) => {
  return data.map((item) => ({
    key: item.key,
    diffFields: determineDiffChildFields(
      item.children as TContractItemsListRecord[]
    )
  }))
}

export const determineDiffChildFields = (children): string[] => {
  const diffFields: string[] = []
  for (const key of getAllChildrenFields(children)) {
    if (
      !children.every(
        (child) => child[key as string] === children[0][key as string]
      )
    ) {
      diffFields.push(key)
    }
  }
  return diffFields
}

export const getAllChildrenFields = (children): string[] => {
  return Array.from(
    new Set(
      children.reduce((acc, child) => {
        return acc.concat(Object.keys(child))
      }, [])
    )
  )
}
